<template>
  <div class="integral">
    <!-- <heads></heads> -->
    <div class="container">
      <div class="list" v-loading="loading">
        <div class="item head">
          <span>类型</span>
          <span>变动前积分</span>
          <span>变动积分</span>
          <span>变动后积分</span>
          <span>时间</span>
        </div>
        <!--利用数组切片切出10条数据展示-->
        <div class="item content" v-for="(item,index) in pageArray" :key="index">
          <span>{{item.pointType==2?'消费':'分享'}}</span>
          <span>{{item.pointBeforeChange}}</span>
          <span class="col">{{ item.onsumptionValue }}</span>
          <span>{{item.pointAfterChange}}</span>
          <span>{{fomateDate(item.createDate)}}</span>
        </div>
      </div>
      <div class="pagination">
        <el-pagination
          background
          layout="prev, pager, next"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="pageNumber"
          :page-size="10"
          :total="total"
        ></el-pagination>
        <div class="tip" @click="smDialogVisible = true">
          积分说明
          <i class="fa fa-question-circle-o" aria-hidden="true"></i>
        </div>
      </div>
    </div>

    <!--积分说明弹框-->
    <el-dialog title="积分说明" :visible.sync="smDialogVisible" width="30%">
      <div v-html="integralDescription"></div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="smDialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import heads from "@/components/comment/heads.vue";
import homeFoots from "@/components/comment/homeFoots.vue";
import banners from "@/components/comment/banners.vue";
import { fomateDate } from "@/util/util.js";
import axios from "axios";
import qs from "qs";

export default {
  name: "integral",
  data() {
    return {
      nav: 0,
      navArray: ["TA的活动", "个人介绍"],
      pageArray: "",
      total: 0,
      pageNumber: 1,
      loading: false,
      smDialogVisible: false
    };
  },
  components: {
    heads,
    homeFoots,
    banners
  },
  computed: {
    integralDescription(){
      return this.$store.state.webInfo.integralDescription;
    }
  },
  methods: {
    fomateDate,
    getNav(index) {
      this.nav = index;
    },
    handleCurrentChange(val) {
      this.loading = false;
      this.requestIntegralMessage(this.nav);
    },
    handleSizeChange(val) {
      console.log("当前页:" + val);
    },
    requestIntegralMessage() {
      axios
        .get(`/mobile/point/pluslist.jhtml`, {
          params: {
            pageSize: 10,
            pageNumber: this.pageNumber
          }
        })
        .then(res => {
          if (res.data.success) {
            this.total = res.data.returnValue.total;
            this.pageArray = res.data.returnValue.pointList;
          }
          this.loading = false;
        });
    }
  },
  mounted() {
    this.loading = true;
    //请求1页 个人积分列表信息
    this.requestIntegralMessage();
  },
  created() {}
};
</script>

<style scoped>
.activityIndex {
  width: 100%;
  height: 100%;
}
.container {
  text-align: left;
  margin-bottom: 20px;
}
.list {
  font-size: 14px;
  width: 100%;
  padding: 0 60px;
  box-sizing: border-box;
  margin-top: 20px;
  min-height: 400px;
}
.pagination {
  display: flex;
  justify-content: space-between;
  padding: 0 60px;
}
.item {
  display: flex;
  align-items: center;
  height: 40px;
}
.head {
  background: #f0eeee;
  border-bottom: 1px solid #cccccc;
  font-weight: bold;
}
.item > span {
  text-align: center;
  width: 25%;
  display: block;
}
.content {
  border-bottom: 1px solid #e4e0e0;
  color: #656565;
  /* min-height: 500px; */
}
.col {
  color: #5fc96f;
}
.tip {
  margin-right: 30px;
  cursor: pointer;
  color: rgb(0, 100, 255);
}
</style>



// WEBPACK FOOTER //
// src/components/userview/integral.vue